import React from "react";

export type AppVersion = "web" | "harvard";

interface VersionSwitcherProps {
  current: AppVersion;
}

export const VersionSwitcher: React.FC<VersionSwitcherProps> = ({
  current,
}) => {
  return (
    <div className="version-switcher print:hidden fixed bottom-4 right-4 z-[100] flex items-center gap-1 rounded-full border border-neutral-200 bg-white/95 px-2 py-1.5 shadow-lg backdrop-blur-sm">
      <a
        href="#/"
        className={`rounded-full px-3 py-1 text-xs font-medium transition-colors ${
          current === "web"
            ? "bg-neutral-900 text-white"
            : "text-neutral-600 hover:bg-neutral-100"
        }`}
      >
        Web
      </a>
      <a
        href="#/cv"
        className={`rounded-full px-3 py-1 text-xs font-medium transition-colors ${
          current === "harvard"
            ? "bg-neutral-900 text-white"
            : "text-neutral-600 hover:bg-neutral-100"
        }`}
      >
        PDF CV
      </a>
    </div>
  );
};
